import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// components bootstrap
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Alert } from "react-bootstrap";
// components custom
import _Button from "../../../generic/_Button";
import MessageTextBox from "../../../../pages/Campaigns/migrate/messages/MessageTextBox";
import OptionLabelsSelector from "../../../campaigns/OptionLabelsSelector";
import _Input from "../../../generic/_Input";
import _Suggestions from "../../../generic/_Suggestions";
import MultiBadgeSelector from "../../../campaigns/MultiBadgeSelector";
// form
import { useFormik } from "formik";
import * as Yup from "yup";
// utils
import { today } from "../../../../utils/dateHelpers";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { ErrorMessage, SuccessMessage } from "../../../../utils/toastify";
// auth
import { useAuth } from "../../../../Context/AuthContext";
import { errorLabels } from "../../../../utils/helpers";

const _ModalEdit = (props) => {
  const auth = useAuth();
  let { token, uid_partner, uid_user } = auth.getSessionData();
  const { visible, title = "", type, onClose, data = {} } = props;
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      uid: data.uidCampaign,
      uidUser: uid_user,
      isRcs: false,
      isSms: false,
      isScheduled: false,
      rcsmessage: "",
      message: "",
      msisdn: "",
      template: "",
      dateSend: "",
      proghour: "",
      hour: 0,
      minute: 0,
      jDetails: {},
      fieldsInfo: [],
      listShortLinks: [],
      fallback: "",
    },
    validationSchema: Yup.object({
      message: Yup.string()
        .min(3, "El mensaje SMS debe tener al menos 3 caracteres")
        .max(399, "El mensaje SMS no puede tener más de 399 caracteres")
        .test(
          "required-message",
          "El mensaje SMS es requerido",
          function (value) {
            return type === "sms" ? !!value : true;
          }
        ),
      rcsmessage: Yup.string()
        .min(3, "El mensaje RCS debe tener al menos 3 caracteres")
        .max(2000, "El mensaje RCS no puede tener más de 2000 caracteres")
        .test(
          "required-rcsmessage",
          "El mensaje RCS es requerido",
          function (value) {
            return type === "rcs" ? !!value : true;
          }
        ),
      fallback: Yup.string()
        .min(3, "El fallback SMS debe tener al menos 3 caracteres")
        .max(399, "El fallback SMS no puede tener más de 399 caracteres")
        .test(
          "required-fallback",
          "El fallback SMS es requerido",
          function (value) {
            return type === "rcs" ? !!value : true;
          }
        ),
      dateSend: Yup.string().test(
        "required-dateSend",
        "La fecha de envio es requerida",
        function (value) {
          return this.parent.isScheduled ? !!value : true;
        }
      ),
      proghour: Yup.string().test(
        "required-proghour",
        "La hora de envio es requerida",
        function (value) {
          return this.parent.isScheduled ? !!value : true;
        }
      ),
    }),

    onSubmit: async (values) => {
      /* eslint-disable */
      const {
        listShortLinks,
        fieldsInfo,
        dateSend,
        rcsmessage,
        isRcs,
        isSms,
        fallback,
        ...rest
      } = values;
      const dataSubmit = {
        ...rest,
        isRcs: type === "rcs",
        isSms: type === "sms",
        message: type === "sms" ? values.message : rcsmessage,
        hour: values.isScheduled ? values.proghour.split(":")[0] : 0,
        minute: values.isScheduled ? values.proghour.split(":")[1] : 0,
        date: dateSend,
        jDetails: JSON.stringify(values.jDetails),
      };

      if (type === "rcs") {
        dataSubmit.jDetails = JSON.stringify({
          fallback,
        });
      }
      await onAction(dataSubmit);
    },
  });

  useEffect(() => {
    if (visible) {
      formik.resetForm();
    }
  }, [visible]);

  const getShortLinks = () => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/shortLinks/${uid_partner}`,
      {},
      token
    ).then((response) => {
      formik.setFieldValue(
        "listShortLinks",
        response.data.filter((x) => x.active),
        false
      );
    });
  };

  const getExtraFieldsInfo = (uidDatabase) => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/fieldsdatabase/${uidDatabase}`,
      {},
      token
    ).then((response) => {
      formik.setFieldValue("fieldsInfo", response.data, false);
    });
  };

  useEffect(() => {
    getShortLinks();
    if (data.uidDatabase !== "") {
      getExtraFieldsInfo(data.uidDatabase);
    }
  }, [data, visible]);

  const _onClose = () => {
    if (onClose) onClose();
    formik.resetForm();
  };

  const renderChannel = () => {
    switch (type) {
      case "sms":
        return (
          <div className="border rounded-lg px-4 py-2 my-2">
            <div className="text-xl font-bold text-gray-600">Mensaje SMS</div>
            <MessageTextBox
              value={formik.values.message}
              onChange={(e) => formik.setFieldValue("message", e.target.value)}
              name="message"
              onBlur={formik.handleBlur}
              isError={formik.errors && formik.errors.message}
              errorMsg={
                formik.errors && formik.touched ? formik?.errors.message : ""
              }
              template={formik.values.template}
              fieldsInfo={formik.values.fieldsInfo}
            />
            <div className="grid grid-cols-2 gap-4">
              <div className="">
                <div className="text-xl font-bold text-gray-600">
                  Plantillas
                </div>
                <Alert variant="secondary" className="Notice">
                  Selecciona las plantillas que deseas utilizar en la campaña
                </Alert>
                <div className="grid grid-cols-1 gap-4">
                  <MultiBadgeSelector
                    onChange={(value) => handleTemplate(value, "message")}
                    fieldsInfo={formik.values.fieldsInfo}
                  />
                </div>
              </div>
              <div>
                <div className="text-xl font-bold text-gray-600">
                  URLs cortas
                </div>
                <Alert variant="secondary" className="Notice">
                  Selecciona URLs cortas que deseas utilizar en la campaña
                </Alert>
                <div className="grid grid-cols-1 gap-4">
                  <_Suggestions
                    placeholder="https://..."
                    handleChange={(e) => handleSuggestions(e, "message")}
                    options={
                      formik.values.listShortLinks?.map((item) => ({
                        value: item.shortlinks,
                        label: item.displayname,
                      })) || []
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        );
      case "rcs":
        return (
          <>
            <div className="border rounded-lg px-4 py-2 my-2">
              <div className="text-xl font-bold text-gray-600">Mensaje RCS</div>
              <_Input
                title="Mensaje"
                name="rcsmessage"
                id="rcsmessage"
                alias="textarea"
                required
                rows={5}
                placeholder="Escriba su mensaje"
                value={formik.values.rcsmessage}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                errors={formik.errors && formik.errors.rcsmessage}
                isError={
                  formik.errors && formik.errors.rcsmessage ? true : false
                }
              />

              <div className="grid grid-cols-2 gap-4">
                {" "}
                <div className="">
                  <div className="text-xl font-bold text-gray-600">
                    Plantillas
                  </div>
                  <Alert variant="secondary" className="Notice">
                    Selecciona las plantillas que deseas utilizar en la campaña
                  </Alert>
                  <div className="grid grid-cols-1 gap-4">
                    <MultiBadgeSelector
                      onChange={(value) => handleTemplate(value, "rcsmessage")}
                      fieldsInfo={formik.values.fieldsInfo}
                    />
                  </div>
                </div>
                <div>
                  <div className="text-xl font-bold text-gray-600">
                    URLs cortas
                  </div>
                  <Alert variant="secondary" className="Notice">
                    Selecciona URLs cortas que deseas utilizar en la campaña
                  </Alert>
                  <div className="grid grid-cols-1 gap-4">
                    <_Suggestions
                      placeholder="https://..."
                      handleChange={(e) => handleSuggestions(e, "rcsmessage")}
                      options={
                        formik.values.listShortLinks?.map((item) => ({
                          value: item.shortlinks,
                          label: item.displayname,
                        })) || []
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="border rounded-lg px-4 py-2 my-2">
              <div className="text-xl font-bold text-gray-600">Fallback</div>

              <MessageTextBox
                value={formik.values.fallback}
                onChange={(e) =>
                  formik.setFieldValue("fallback", e.target.value)
                }
                name="fallback"
                onBlur={formik.handleBlur}
                isError={formik.errors && formik.errors.fallback}
                errorMsg={
                  formik.errors && formik.touched ? formik?.errors.fallback : ""
                }
                template={formik.values.template}
                fieldsInfo={formik.values.fieldsInfo}
              />
              <div className="grid grid-cols-2 gap-4">
                <div className="">
                  <div className="text-xl font-bold text-gray-600">
                    Plantillas
                  </div>
                  <Alert variant="secondary" className="Notice">
                    Selecciona las plantillas que deseas utilizar en la campaña
                  </Alert>
                  <div className="grid grid-cols-1 gap-4">
                    <MultiBadgeSelector
                      onChange={(value) => handleTemplate(value, "fallback")}
                      fieldsInfo={formik.values.fieldsInfo}
                    />
                  </div>
                </div>
                <div>
                  <div className="text-xl font-bold text-gray-600">
                    URLs cortas
                  </div>
                  <Alert variant="secondary" className="Notice">
                    Selecciona URLs cortas que deseas utilizar en la campaña
                  </Alert>
                  <div className="grid grid-cols-1 gap-4">
                    <_Suggestions
                      placeholder="https://..."
                      handleChange={(e) => handleSuggestions(e, "fallback")}
                      options={
                        formik.values.listShortLinks?.map((item) => ({
                          value: item.shortlinks,
                          label: item.displayname,
                        })) || []
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        );

      default:
    }
  };

  const handleSuggestions = (value, key) => {
    return formik.setFieldValue(`${key}`, value);
  };

  const handleTemplate = (value, key) => {
    return formik.setFieldValue(`${key}`, `${formik.values[key]} {${value}}`);
  };

  console.log(formik.errors);
  const onValidate = async () => {
    setLoading(true);

    try {
      const isValid = await formik.validateForm();
      console.log(isValid);

      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const onAction = async (data = {}) => {
    const mapUri = {
      sms: {
        create: "createCampaignMessage",
        program: "programCampaignMessage",
      },
      rcs: {
        create: "createCampaignMessage",
        program: "programCampaignMessage",
      },
      whatsapp: {
        create: "createCampaignWhatsMessage",
        program: "programCampaignWhats",
      },
      email: {
        create: "createCampaignEmailMessage",
        program: "programCampaignEmail",
      },
    };

    const isScheduled = formik.values.isScheduled ? "program" : "create";

    let uri = `${ApiEndpoint}campaigns/${mapUri[type][isScheduled]}`;

    const res = await httpClient("POST", uri, data, token);

    if (res?.data?.error) {
      const messageError =
        res?.data?.Errorcode === "0"
          ? "No cuenta con SMS suficientes para la campaña"
          : "Ha ocurrido un error";
      throw new Error(messageError);
    }

    _onClose();
    SuccessMessage("Operación exitosa");
  };

  return (
    <Modal show={visible} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="flex items-center gap-2 justify-between">
            <div className="flex justify-start gap-1 text-xl font-semibold text-gray-600">
              {title} <div className="uppercase">{type}</div>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {renderChannel()}

        <div className="border rounded-lg px-4 py-2">
          <div className="text-xl font-bold text-gray-600">
            Opciones de Envio
          </div>
          <div className="space-y-4">
            <OptionLabelsSelector
              onChange={(value) => formik.setFieldValue("isScheduled", value)}
              value={formik.values.isScheduled}
              options={[
                {
                  value: false,
                  label: "Enviar ahora",
                },
                {
                  value: true,
                  label: "Programar",
                },
              ]}
            />
          </div>
          {formik.values.isScheduled ? (
            <>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col py-2">
                  <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
                    Fecha de envio:
                    <span className="text-red-700 mx-1">*</span>
                  </label>
                  <Form.Control
                    type="date"
                    name="dateSend"
                    id="dateSend"
                    value={formik.values.dateSend}
                    today={today()}
                    required
                    onChange={formik.handleChange}
                    placeholder="Fecha de envio"
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.errors && formik.errors.dateSend
                        ? formik.errors.dateSend
                        : ""
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.dateSend}
                  </Form.Control.Feedback>
                </div>

                <div className="flex flex-col py-2">
                  <label className="text-gray-700 font-semibold text-sm flex justify-start align-top mb-2">
                    Hora de Envio:
                    <span className="text-red-700 mx-1">*</span>
                  </label>
                  <Form.Control
                    type="time"
                    name="proghour"
                    id="proghour"
                    required
                    onChange={formik.handleChange}
                    value={formik.values.proghour}
                    onBlur={formik.handleBlur}
                    placeholder="Hora de envio"
                    isInvalid={
                      formik.errors && formik.errors.proghour
                        ? formik.errors.proghour
                        : ""
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.proghour}
                  </Form.Control.Feedback>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4">
                <div className="flex flex-col py-2">
                  <Alert
                    key={"secondary"}
                    variant={"secondary"}
                    className="Notice"
                  >
                    <b>Nota:</b> Si la hora seleccionada ya transcurrió la
                    campaña se ejecutará inmediatamente.
                  </Alert>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cancelar"
          style="none"
          onClick={_onClose}
          loading={loading}
        />
        <_Button
          title="Guardar"
          style="primary"
          onClick={async () => await onValidate()}
          loading={loading}
        />
      </Modal.Footer>
    </Modal>
  );
};

_ModalEdit.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
  onClose: PropTypes.func,
  data: PropTypes.object,
};

export default _ModalEdit;
